(ns minorodata.transform.model
  (:require [mold.core :as m :refer-macros [defmodel]]
            [minorodata.users.model :refer [searchable-user]]))

(declare ->transform-tag
         ->transform
         ->unsaved-transform
         ->transforms-panel
         ->transform-version
         ->transform-versions-list
         ->transform-status
         ->transform-status-list
         ->transform-master
         ->transform-queue)

(defmodel transform-tag
  {:value [::m/identity ::m/string "Uniq tag identifier"]
   :label [::m/string "Tag label"]})


(defmodel transform
  {:id              [::m/identity ::m/req ::m/string "Uniq id"]
   :master-id       [::m/string "Transform master id"]
   :group-id        [::m/string "Group id"]
   :client-id       [::m/string "Client id"]
   :updated-by      {::m/type     ::m/ref
                     ::m/ref-type searchable-user
                     ::m/doc      "Related user"}
   :created-by      {::m/type     ::m/ref
                     ::m/ref-type searchable-user
                     ::m/doc      "Related user"}
   :updated-at      [::m/string "Updated date"]
   :created-at      [::m/string "Created date"]
   :last-run        [::m/string ::m/nilable "Last run date"]
   ;; meta
   :name            [::m/string ::m/nilable "Transform name"]
   :description     [::m/string ::m/nilable "Transform description"]
   :tags            {::m/type        ::m/ref
                     ::m/cardinality ::m/many
                     ::m/ref-type    transform-tag
                     ::m/doc         "Transform tags"}
   :status          [::m/keyword "Transform status"]
   :input-tables    [::m/vector "Input dependencies"]
   :output-tables   [::m/vector "Output dependencies"]
   :order           [::m/number ::m/nilable "UI only field to preserve the display order"]
   ;; sql
   :command         [::m/string "Original SQL"]
   :cleaned-command [::m/string ::m/nilable "Cleaned SQL"]
   :statements      [::m/vector ::m/nilable "Cleaned and splitted out SQL"]
   ;; schedule
   :schedule-spec   [::m/map ::m/nilable "{:cron string?}"]
   ;; flags
   :ignore-parser   [::m/bool "Hand written dependencies"]
   :is-full         [::m/bool "Full"]
   :is-temp         [::m/bool "Temp"]
   :stale           [::m/bool "Is this transform are stale"]

   ;; env specific
   :environmend-id     [::m/string ::m/nilable "Environment id"]
   :modification-state [::m/string ::m/nilable "Modification state"]}
  {:ref-mapping {:tags :transform-tag/value}})


(defmodel unsaved-transform
  {:id            [::m/identity ::m/req "Uniq id"]
   :command       [::m/string "Transform SQL"]
   ;; meta
   :name          [::m/string ::m/nilable "Transform name"]
   :description   [::m/string ::m/nilable "Transform description"]
   :tags          {::m/type        ::m/ref
                   ::m/cardinality ::m/many
                   ::m/ref-type    transform-tag
                   ::m/doc         "Transform tags"}
   :status        [::m/keyword "Transform status"]
   :input-tables  [::m/vector "Input dependencies"]
   :output-tables [::m/vector "Output dependencies"]
   ;; schedule
   :schedule-spec [::m/map ::m/nilable "{:cron string?}"]
   ;; flags
   :ignore-parser [::m/bool "Hand written dependencies"]
   :is-full       [::m/bool "Full"]
   :is-temp       [::m/bool "Temp"]}
  {:ref-mapping {:tags :transform-tag/value}})


(defmodel transforms-panel
  {:transforms            {::m/type        ::m/ref
                           ::m/cardinality ::m/many
                           ::m/ref-type    transform
                           ::m/doc         "Link to transforms related to current panel state"}
   :active-transform      {::m/type     ::m/ref
                           ::m/ref-type transform
                           ::m/doc      "Link to the active panel transform"}
   :sql-parse-error       [::m/string]
   :show-parse-error      [::m/bool "Show sql parsing error"]
   :dep-validation-status [::m/string "Result of dependency validation"]
   :dep-validation-error  [::m/string "Dependency validation error"]
   :total-pages           [::m/number]
   :page                  [::m/number]
   :items-per-page        [::m/number]
   :order-by              [::m/keyword]
   :order-dir             [::m/keyword]
   :latest-order-index    [::m/number ::m/nilable]
   :fullscreen-editor     [::m/bool]
   :unit-test-modal       [::m/bool]}
  {:singleton true})


(defmodel transform-version
  {:transform-id [::m/identity ::m/req ::m/string "Transform id"]
   :master-id    [::m/string "Transform master id"]
   :created-by   {::m/type     ::m/ref
                  ::m/ref-type searchable-user
                  ::m/doc      "Related user"}
   :created-at   [::m/string "Created date"]
   :version-name [::m/string "Transform version name"]
   :order        [::m/number ::m/nilable "UI only field to preserve the display order"]})


(defmodel transform-versions-list
  {:total-pages        [::m/number ::m/nilable]
   :page               [::m/number]
   :items-per-page     [::m/number]
   :latest-order-index [::m/number ::m/nilable]
   :current            [::m/string "Current transform id"]
   :selected           [::m/string ::m/nilable "Transform to compare with"]}
  {:singleton true})


(defmodel transform-status
  {:transform-id [::m/identity ::m/req ::m/string "Transform id"]
   :status       [::m/string "Last run status"]
   :created-at   [::m/string "When transform was launched time"]
   :started-at   [::m/string "When transform started executing"]
   :finished-at  [::m/string "When transform finished"]})

(defmodel transform-status-list
  {:statuses [::m/vector]}
  {:singleton true})

(defmodel transform-master
  {:master-id [::m/identity ::m/req ::m/string "Master transform id"]
   :transform {::m/type     ::m/ref
               ::m/ref-type transform
               ::m/doc      "Transform"}})

(defmodel transform-queue
  {:data [::m/vector "Vector of queue items"]}
  {:singleton true})
